// src/router/router.js

import { createRouter, createWebHistory } from 'vue-router';

import AvatarTomView from '../components/AvatarTomView.vue';
import AvatarRubView from '../components/AvatarRubView.vue';

import OverUsView from '../components/OverUsView.vue';
import HygieneView from '../components/HygieneView.vue';
import ContactView from '../components/ContactView.vue';
import BranchenView from '../components/BranchenView.vue';
import ImpressumView from '../components/ImpressumView.vue';
import LeistungenView from '../components/LeistungenView.vue';
import DatenschutzView from '../components/DatenschutzView.vue';
import OverUsViewChoose from '../components/OverUsViewChoose.vue';
import WissenView from '../components/WissenView.vue';

import GastroView from '../components/GastroView.vue';
import GebaudeReinigungView from '../components/GebaudeReinigungView.vue';
import GemeinschaftsverpflegungView from '../components/GemeinschaftsverpflegungView.vue';
import KindergartenView from '../components/KindergartenView.vue';
import KuecheView from '../components/KuecheView.vue';
import PflegeView from '../components/PflegeView.vue';


// ============================================================
// DEFINITION DER ROUTEN
// ============================================================

const routes = [

  // ==========================================================
  // STARTSEITE
  // ==========================================================

  {
    path: '/',
    name: 'Home',
    component: () => import('../components/HomeView.vue'),

    meta: {
      title: 'TR-Hygieneprofis | Hygieneberatung & Hygieneschulungen',

      description:
        'TR-Hygieneprofis – professionelle Hygieneberatung, Hygieneschulungen, HACCP-Konzepte und praxisnahe Hygienelösungen für Gastronomie, Lebensmittelbetriebe, Pflege, Kitas und weitere Einrichtungen.'
    }
  },


  // ==========================================================
  // AVATARE
  // ==========================================================

  {
    path: '/rub',
    name: 'Ruben',
    component: AvatarRubView,

    meta: {
      title: 'Ruben Rohletter | TR-Hygieneprofis',

      description:
        'Ruben Rohletter von TR-Hygieneprofis Wetzlar Ansprechpartner für praxisnahe Hygieneberatung, Hygienekonzepte und Schulungen.'
    }
  },


  {
    path: '/tom',
    name: 'Tom',
    component: AvatarTomView,

    meta: {
      title: 'Thomas Schermuly | TR-Hygieneprofis',

      description:
        'Thomas Schermuly von TR-Hygieneprofis aus Wetzlar professionelle Unterstützung rund um Hygiene, Schulungen und sichere Hygienelösungen.'
    }
  },


  // ==========================================================
  // LEISTUNGEN
  // ==========================================================

  {
    path: '/leistungen',
    name: 'Leistungen',
    component: LeistungenView,

    meta: {
      title: 'Hygieneberatung & Hygienekonzepte | TR-Hygieneprofis',

      description:
        'Hygieneberatung, Hygienekonzepte, HACCP, Schulungen, Reinigungs- und Desinfektionspläne, Allergenmanagement, Lebensmittelsicherheit und weitere Hygieneleistungen von TR-Hygieneprofis.'
    }
  },


  // ==========================================================
  // BRANCHEN – ÜBERSICHT
  // ==========================================================

  {
    path: '/branchen',
    name: 'Branchen',
    component: BranchenView,

    meta: {
      title: 'Hygieneberatung für verschiedene Branchen | TR-Hygieneprofis',

      description:
        'TR-Hygieneprofis unterstützt Gastronomie, Gemeinschaftsverpflegung, Fleischereien, Lebensmittelproduktion, Kitas, Schulen, Pflegeeinrichtungen, Gebäudereinigung und weitere Betriebe.'
    }
  },


  // ==========================================================
  // BRANCHEN – GASTRONOMIE
  // ==========================================================

  {
    path: '/gastronomie',
    name: 'Gastronomie',
    component: GastroView,

    meta: {
      title: 'Hygieneberatung für Gastronomie | TR-Hygieneprofis',

      description:
        'Professionelle Hygieneberatung für Gastronomie, Restaurants, Cafés, Hotels und gastronomische Betriebe. HACCP, Hygienekonzepte, Schulungen und praxisnahe Lösungen.'
    }
  },


  // ==========================================================
  // BRANCHEN – GEMEINSCHAFTSVERPFLEGUNG
  // ==========================================================

  {
    path: '/gemeinschaftsverpflegung',
    name: 'Gemeinschaftsverpflegung',
    component: GemeinschaftsverpflegungView,

    meta: {
      title: 'Hygiene in der Gemeinschaftsverpflegung | TR-Hygieneprofis',

      description:
        'Hygieneberatung und Hygienekonzepte für Gemeinschaftsverpflegung, Kantinen, Schulen, Kitas, Kliniken und weitere Einrichtungen mit gemeinschaftlicher Lebensmittelversorgung.'
    }
  },


  // ==========================================================
  // BRANCHEN – GEBÄUDEREINIGUNG
  // ==========================================================

  {
    path: '/gebaeudereinigung',
    name: 'Gebaudereinigung',
    component: GebaudeReinigungView,

    meta: {
      title: 'Hygiene für Gebäudereinigung | TR-Hygieneprofis',

      description:
        'Praxisnahe Hygieneberatung für Unternehmen der Gebäudereinigung. Reinigungspläne, Hygienekonzepte, Schulungen und professionelle Lösungen für Reinigung und Desinfektion.'
    }
  },


  // ==========================================================
  // BRANCHEN – KINDERGARTEN
  // ==========================================================

  {
    path: '/kindergarten',
    name: 'Kindergarten',
    component: KindergartenView,

    meta: {
      title: 'Hygiene im Kindergarten & in der Kita | TR-Hygieneprofis',

      description:
        'Hygieneberatung und Hygienekonzepte für Kindergärten, Kitas und Einrichtungen der Kinderbetreuung. Praxisnahe Unterstützung bei Hygiene, Reinigung und Lebensmittelsicherheit.'
    }
  },


  // ==========================================================
  // BRANCHEN – PFLEGE
  // ==========================================================

  {
    path: '/pflege',
    name: 'Pflege',
    component: PflegeView,

    meta: {
      title: 'Hygiene in Pflegeeinrichtungen | TR-Hygieneprofis',

      description:
        'Hygieneberatung und Hygienekonzepte für Pflegeeinrichtungen, ambulante Pflegedienste und weitere Einrichtungen im Pflegebereich.'
    }
  },


  // ==========================================================
  // KÜCHE
  // ==========================================================

  {
    path: '/kueche',
    name: 'Kueche',
    component: KuecheView,

    meta: {
      title: 'Hygiene in der Küche | TR-Hygieneprofis',

      description:
        'Professionelle Hygieneberatung für Küchen und Lebensmittelbereiche. Hygienekonzepte, HACCP, Reinigungspläne und praxisnahe Hygienelösungen.'
    }
  },


  // ==========================================================
  // HYGIENE
  // ==========================================================

  {
    path: '/hygiene',
    name: 'Hygiene',
    component: HygieneView,

    meta: {
      title: 'Hygieneberatung & Lebensmittelsicherheit | TR-Hygieneprofis',

      description:
        'Professionelle Hygieneberatung für sichere und funktionierende Prozesse. TR-Hygieneprofis unterstützt Betriebe bei Hygiene, Lebensmittelsicherheit, HACCP und gesetzlichen Anforderungen.'
    }
  },


  // ==========================================================
  // ÜBER UNS
  // ==========================================================

  {
    path: '/ueber-uns',
    name: 'UeberUns',
    component: OverUsView,

    meta: {
      title: 'Über uns | TR-Hygieneprofis',

      description:
        'TR-Hygieneprofis steht für praxisnahe, verständliche und individuelle Hygieneberatung. Lernen Sie unser Team und unsere Arbeitsweise kennen.'
    }
  },


  // ==========================================================
  // ÜBER UNS – AUSWAHL
  // ==========================================================

  {
    path: '/overUsChoose',
    name: 'OverUsChoose',
    component: OverUsViewChoose,

    meta: {
      title: 'Ihr Ansprechpartner | TR-Hygieneprofis',

      description:
        'Finden Sie den passenden Ansprechpartner für Ihre Hygieneberatung im Raum Wetzlar und Hessen bei TR-Hygieneprofis.'
    }
  },


  // ==========================================================
  // WISSEN
  // ==========================================================

  {
    path: '/wissen',
    name: 'Wissen',
    component: WissenView,

    meta: {
      title: 'Hygiene-Wissen & Informationen | TR-Hygieneprofis',

      description:
        'Wissenswertes rund um die Personen hinter TR-Hygieneprofis.'
    }
  },


  // ==========================================================
  // KONTAKT
  // ==========================================================

  {
    path: '/kontakt',
    name: 'Kontakt',
    component: ContactView,

    meta: {
      title: 'Kontakt | TR-Hygieneprofis',

      description:
        'Kontaktieren Sie TR-Hygieneprofis für professionelle Hygieneberatung, Hygieneschulungen, HACCP-Konzepte und individuelle Hygienelösungen.'
    }
  },


  // ==========================================================
  // IMPRESSUM
  // ==========================================================

  {
    path: '/impressum',
    name: 'Impressum',
    component: ImpressumView,

    meta: {
      title: 'Impressum | TR-Hygieneprofis',

      description:
        'Impressum von TR-Hygieneprofis.'
    }
  },


  // ==========================================================
  // DATENSCHUTZ
  // ==========================================================

  {
    path: '/datenschutz',
    name: 'Datenschutz',
    component: DatenschutzView,

    meta: {
      title: 'Datenschutz | TR-Hygieneprofis',

      description:
        'Datenschutzerklärung von TR-Hygieneprofis.'
    }
  }

];


// ============================================================
// ROUTER-INSTANZ
// ============================================================

const router = createRouter({

  history: createWebHistory(),

  routes,

  scrollBehavior() {

    return {
      top: 0
    };

  }

});


// ============================================================
// SEO – TITLE & META DESCRIPTION
// ============================================================

router.afterEach((to) => {

  // ==========================================================
  // SEITENTITEL
  // ==========================================================

  if (to.meta && to.meta.title) {

    document.title = to.meta.title;

  }


  // ==========================================================
  // META DESCRIPTION
  // ==========================================================

  if (to.meta && to.meta.description) {

    let description = document.querySelector(
      'meta[name="description"]'
    );


    // Falls keine Meta Description existiert,
    // wird sie automatisch angelegt.

    if (!description) {

      description = document.createElement('meta');

      description.setAttribute(
        'name',
        'description'
      );

      document.head.appendChild(description);

    }


    description.setAttribute(
      'content',
      to.meta.description
    );

  }


  // ==========================================================
  // CANONICAL URL
  // ==========================================================

  const canonicalUrl =
    `https://www.tr-hygieneprofis.de${to.path}`;


  let canonical = document.querySelector(
    'link[rel="canonical"]'
  );


  // Falls noch kein Canonical-Link existiert,
  // wird dieser automatisch erstellt.

  if (!canonical) {

    canonical = document.createElement('link');

    canonical.setAttribute(
      'rel',
      'canonical'
    );

    document.head.appendChild(canonical);

  }


  canonical.setAttribute(
    'href',
    canonicalUrl
  );

});


// ============================================================
// ROUTER EXPORTIEREN
// ============================================================

export default router;